import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  applicationTypeID: '0',
}

const applicationTypeSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    setApplicationTypeID: (state, action) => {
      state.applicationTypeID = action.payload
    }
  }
})

export const { setApplicationTypeID } = applicationTypeSlice.actions

export default applicationTypeSlice.reducer